import { render, staticRenderFns } from "./SpeedTest.vue?vue&type=template&id=71a267d9&scoped=true&"
import script from "./SpeedTest.vue?vue&type=script&lang=js&"
export * from "./SpeedTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a267d9",
  null
  
)

export default component.exports